import { api } from '../core/_requests'


export const createEvent = async (category, description) => {
  const result = await api.post(`events/${category.toLowerCase().replace(/_/g, '-')}/`, { category, description })
  return result
}
